/** Tokens que uma aplicação pode sobrescrever. Qualquer outra chave é ignorada. */
export const themeTokens = [
  "color-paper", "color-canvas", "color-surface", "color-ink", "color-muted", "color-line",
  "color-accent", "color-accent-strong", "color-accent-soft", "color-on-accent",
  "color-success", "color-success-soft", "color-warning", "color-warning-soft", "color-danger", "color-danger-soft", "color-neutral-soft",
  "color-category-1", "color-category-2", "color-category-3", "color-category-4", "color-category-5", "color-category-6",
  "font-body", "font-heading", "heading-weight", "radius-sm", "radius-md", "sidebar-width",
] as const;
export type ThemeToken = (typeof themeTokens)[number];
export type Theme = Partial<Record<ThemeToken, string>>;

const allowed = new Set<string>(themeTokens);
// Um valor de tema nunca pode fechar a declaração nem abrir outra regra.
const safeValue = /^[^;{}<>]*$/;

/**
 * Aplica o tema de uma aplicação em tempo de execução, sobrescrevendo as variáveis CSS.
 * É assim que a mesma build muda de marca: nenhum componente conhece a aplicação.
 */
export function applyTheme(theme: Record<string, string>, target: HTMLElement = document.documentElement): string[] {
  const applied: string[] = [];
  for (const [token, value] of Object.entries(theme)) {
    if (!allowed.has(token) || !safeValue.test(value)) continue;
    target.style.setProperty(`--${token}`, value);
    applied.push(token);
  }
  return applied;
}

export const categoryColor = (index: number): string => `var(--color-category-${(Math.max(0, index) % 6) + 1})`;
